import { TableCell, TableHead, TableRow } from '@mui/material';

interface SectionHeaderProps {
  label: string;
  valueLabel?: string;
}

const SectionHeader = ({ label, valueLabel = 'Value' }: SectionHeaderProps) => (
  <TableHead>
    <TableRow>
      <TableCell sx={{ bgcolor: 'primary.dark', color: 'primary.contrastText', fontWeight: 700, py: 0.75, fontSize: '0.8rem', width: '60%' }}>
        {label}
      </TableCell>
      <TableCell sx={{ bgcolor: 'primary.dark', color: 'primary.contrastText', fontWeight: 700, py: 0.75, fontSize: '0.8rem', textAlign: 'right' }}>
        {valueLabel}
      </TableCell>
    </TableRow>
  </TableHead>
);

export default SectionHeader;
